<template>
  <v-dialog v-model="dialog" persistent width="750">
    <v-card>
      <!-- Cabecera del formulario -->
      <v-card-title class="headline">
        <v-icon>check</v-icon> {{ titulo }}
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <!-- Cuerpo del formulario -->
      <v-form @submit.prevent="save" v-model="valid" ref="form" lazy-validation>
        <v-card-text class="py-0 px-3">
          <v-container class="p-0" grid-list-md style="min-width: 100%;">
            <v-layout wrap>
              <v-flex xs12>
                <h4 class="texto"><strong>Número:</strong> {{ this.form.numero }}</h4>
              </v-flex>
              <v-flex xs12>
                <h4 class="texto"><strong>Nombre:</strong> {{ this.form.nombres }}</h4>
              </v-flex>

              <v-flex xs12>
                <h4 class="texto">
                  <strong>{{ subtitulo_detalle }} </strong>
                </h4>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_papeleta"
                  class="elevation-1 tabla-comprimida-light"
                  hide-actions
                  :headers="headers"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.dias }}</td>
                    <!-- <td class="text-xs-center">{{ props.item.estado }}</td> -->
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex
              xs12
              v-if="
                lista_reprogramaciones.length > 0 &&
                  (form.tipo == 'FR' || form.tipo == 'R')
              "
            >
              <h4 class="subtitulo-uso"><strong>Detalle de reprogramación de vacación</strong></h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  v-if="
                    lista_reprogramaciones.length > 0 &&
                      (form.tipo == 'FR' || form.tipo == 'R')
                  "
                  :items="lista_reprogramaciones"
                  class="elevation-1 tabla-comprimida-light"
                  hide-actions
                  :headers="headers_reprogramaciones"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">{{ props.item.secuencia }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_desde }}</td>
                    <td class="text-xs-center">{{ props.item.fecha_hasta }}</td>

                    <td class="text-xs-center">{{ props.item.total_dias }}</td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
            <v-flex xs12>
              <h4 class="subtitulo-uso">
                <strong>{{ subtitulo_seguimiento }}</strong>
              </h4>
            </v-flex>
            <v-layout>
              <v-flex xs12>
                <v-data-table
                  :items="lista_detalle"
                  class="elevation-1 tabla-comprimida-light"
                  hide-actions
                  :headers="headers2"
                >
                  <template v-slot:items="props">
                    <td class="text-xs-center">
                      {{ props.item.fecha_registro }}
                    </td>
                    <td class="text-xs-center">{{ props.item.estado }}</td>
                    <td class="text-xs-center">{{ props.item.usuario }}</td>
                    <td class="text-xs-center">{{ props.item.jefe }}</td>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="rgba(4, 8, 194, 0.35)" @click.native="close()">
            <v-icon>cancel</v-icon> ACEPTAR
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate"; // Importación de mixin de validaciones

export default {
  // Definición de mixins importados
  mixins: [validate],
  // Variables iniciales
  data() {
    return {
      dialog: false,
      user: this.$storage.get("user"),
      form: {
        funcionario: {
          nombre: ""
        }
      },
      //url: 'vCronoVacass',
      valid: false,
      titulo: "Ver programación de vacaciones",
      subtitulo_detalle: "Detalle de vacación programada",
      subtitulo_seguimiento: "Seguimiento de vacación programada",
      loading: false,
      estado_vacacion: [],
      nombre: null,
      fecha_ingreso: null,
      fecha_desde: "",
      fecha_hasta: "",
      persona: null,
      saldo: null,
      periodo: null,
      id: null,
      lista_papeleta: [],
      lista_detalle: [],
      lista_reprogramaciones: [],
      headers: [
        { text: "Fecha desde", sortable: false, align: "center" },
        { text: "Fecha hasta", sortable: false, align: "center" },
        { text: "Total días programados", sortable: false, align: "center" }
        //   {text: 'Estado',sortable: false,align: 'center'},
      ],
      headers2: [
        { text: "Fecha de registro", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" },
        { text: "Usuario", sortable: false, align: "center" },
        { text: "Solicitud enviada a:", sortable: false, align: "center" }
      ],
      headers_reprogramaciones: [
        { text: "Nro", sortable: false, align: "center" },
        { text: "Fecha desde", sortable: false, align: "center" },
        { text: "Fecha hasta", sortable: false, align: "center" },
        { text: "Dias", sortable: false, align: "center" },
        { text: "Estado", sortable: false, align: "center" }
      ]
    };
  },
  async mounted() {
    this.$bus.$on(
      "openDialogVerDetalleUsoFuncionarioNormalRRHH",
      async item => {
        this.form = item;
        if (this.form.tipo == "FR") {
          await this.cargarReprogramaciones();
          this.titulo = "Ver reprogramación de vacaciones";
          this.subtitulo_detalle =
            "Detalle de vacación programada a ser reprogramada";
          this.subtitulo_seguimiento =
            "Seguimiento de reprogramación de vacación";
        }
        if (this.form.tipo == "R") {
          await this.cargarReprogramaciones();
          await this.cargarReprogramaciones();
          this.titulo = "Ver reprogramación de vacación";
          this.subtitulo_detalle = "Detalle de vacación reprogramada";
          this.subtitulo_seguimiento = "Seguimiento de vacación reprogramada";
        }
        this.form.id = parseInt(this.form.id);
        this.cargarTablaPapeleta();
        this.dialog = true;
        await this.cargarSeguimiento();
      }
    );
  },

  methods: {
    close() {
      this.form = {
        funcionario: {
          nombre: ""
        }
      };
      this.lista_papeleta = [];
      this.loading = false;
      this.valid = false;
      this.$bus.$emit("closeDialogVerDetalleUsoFuncionarioNormalRRHH");
      this.dialog = false;
    },
    async cargarReprogramaciones() {
      try {
        this.lista_reprogramaciones = [];
        let respuesta = await this.$service.graphql({
          query: `
              query{
                  runQuery(consulta:"select * from vacaciones.v_vacaciones_reprogramadas vsvp where vsvp.id_padre =${this.form.id_vacacion} and vsvp.id_estado<>9"){
                      respuesta
                  }
                  }
              `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          respuesta = respuesta.runQuery.respuesta;
          this.lista_reprogramaciones = respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarTablaPapeleta() {
      const elemento = {
        fecha_desde: this.form.fecha_desde,
        fecha_hasta: this.form.fecha_hasta,
        dias: this.form.dias
      };
      this.lista_papeleta.push(elemento);
    },
    async cargarSeguimiento() {
      try {
        let respuesta;
        let id_vaca_programada = parseInt(this.form.id_vacacion);
        if (this.form.tipo == "FR") {
          //SEGUIMIENTO DE LOS HIJOS
          id_vaca_programada = parseInt(
            this.lista_reprogramaciones[0].id_vacacion_programada
          );
        }
        respuesta = await this.$service.graphql({
          query: `
			  query{
				  runQuery(consulta:"select * from vacaciones.v_seguimiento_vaca_progra vsvp  where vsvp.id_vaca_progra =${id_vaca_programada}"){
					  respuesta
				  }
				  }
			  `
        });
        respuesta = respuesta.runQuery.respuesta;
        this.lista_detalle = respuesta;
      } catch (error) {
        console.log(error);
      }
    }
  }
};
</script>

<style scoped>
.titulo {
  font-size: 1.07em;
  color: rgb(0, 77, 128);
  font-weight: bold;
}
.texto {
  font-size: 1.07em;
  color: rgb(0, 50, 83);
}
.subtitulo-uso {
  font-size: 1.35em;
  color: rgb(0, 77, 128);
  font-weight: bolder;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/vacacion_rrhh/dialogs/VerDetalle.vue